<h3 class="w-100">Ustawienia:</h3>
    <div fxLayoutAlign="center center"
        style="display:flex;gap:20px;align-items:center;margin-bottom:10px;padding-top:20px; flex-wrap:wrap;">
        <!-- <button mat-flat-button class="btn-action btn-with-icon" color="accent"
            (click)="router.navigate(['rekbot', elementId])"><img style="width:25px;" src="/assets/img/back.png"
                alt="">Powrót</button> -->

        <!-- <button mat-flat-button color="accent"
            (click)="router.navigate(['/email-config-list', elementId])">Edytuj ustawienia email</button> -->

        <!-- <button mat-flat-button class="btn btn-primary btn-action" color="accent"
            (click)="router.navigate(['/receipt-creator', elementId])">Kreator paragonów</button> -->

        <button mat-flat-button class="btn btn-primary btn-action" color="accent"
            (click)="fetchDirectRekbotSettings()">Pobierz ustawienia z Rekbot-a</button>

        <button mat-flat-button class="btn btn-primary btn-action" color="accent"
            (click)="sendNewRekbotSettings()">Wyślij nowe ustawienia do Rekbot-a</button>

        <button mat-flat-button class="btn btn-primary btn-action" color="accent"
            (click)="fetchSmtpFromRekbot()">Pokaż
            ustawienia SMTP Rekbot-a</button>

        <button mat-flat-button class="btn btn-primary btn-action" color="accent"
            (click)="sendCurrentSMTPSetting()">Wyślij aktualne ustawienia SMTP do Rekbot-a</button>

        <button mat-flat-button class="btn btn-primary btn-action" color="accent"
            (click)="decodeLocationData()">Pobierz lokalizację z Google Maps</button>


        <button mat-flat-button class="btn btn-primary btn-action" color="accent"
            (click)="generateStoreAPIKey()">Generuj nowy klucz API</button>
        <button mat-flat-button class="btn btn-primary btn-action" color="accent" (click)="clearReceipts()">Wyczyść
            paragony</button>


    </div>

<div class="row">
    <div class="col">
        <div class="row" *ngIf="!settingsExist" style="margin-bottom:30px;">
            <div class="col">
                <h3 style="color:red;">Brak zapisanych ustawień dla aktualnego Rekbota</h3>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <h4>Ustawienia dźwięku</h4>
            </div>
        </div>

        <div class="d-flex flex-row gap-5 flex-wrap justify-content-start align-items-center" style="margin-top:15px;">
                <mat-slide-toggle class="example-margin" [checked]="rekbotSettings.sound_mute"
                    [(ngModel)]="rekbotSettings.sound_mute" [disabled]="disabled">
                    Wyciszenie
                </mat-slide-toggle>
                <span>
                    Głośność
                    <mat-slider min="0" max="100" step="1" showTickMarks>
                    <input matSliderThumb [(ngModel)]="rekbotSettings.sound_volume" #slider>
                </mat-slider>
                {{ slider.value }}%
                </span>
            <div class="col"></div>
        </div>
        <hr>
        <div class="row">
            <div class="col">
                <h4>Przyjmowanie</h4>
            </div>
        </div>
        <div class="row" style="margin-top:15px;">
            <div class="col-2">
                <mat-slide-toggle class="example-margin" [checked]="rekbotSettings.receive_bottles"
                    [(ngModel)]="rekbotSettings.receive_bottles" [disabled]="disabled">
                    Butelki
                </mat-slide-toggle>
            </div>
            <div class="col-2">
                <mat-slide-toggle class="example-margin" [checked]="rekbotSettings.receive_cans"
                    [(ngModel)]="rekbotSettings.receive_cans" [disabled]="disabled">
                    Puszki
                </mat-slide-toggle>
            </div>
            <div class="col-6"></div>
        </div>
        <hr>

        <div class="row">
            <div class="col">
                <h4>Godziny pracy:</h4>
            </div>
        </div>

        <app-rekbot-day-open-hours [settingsOpenHours]="rekbotSettings.open_hours[0]"
            [timeValidationErrors]="rekbotTimeValidation[0]">
        </app-rekbot-day-open-hours>
        <hr style="width:75%; margin:auto;">

        <app-rekbot-day-open-hours [settingsOpenHours]="rekbotSettings.open_hours[1]"
            [timeValidationErrors]="rekbotTimeValidation[1]">
        </app-rekbot-day-open-hours>
        <hr style="width:75%; margin:auto;">

        <app-rekbot-day-open-hours [settingsOpenHours]="rekbotSettings.open_hours[2]"
            [timeValidationErrors]="rekbotTimeValidation[2]">
        </app-rekbot-day-open-hours>
        <hr style="width:75%; margin:auto;">

        <app-rekbot-day-open-hours [settingsOpenHours]="rekbotSettings.open_hours[3]"
            [timeValidationErrors]="rekbotTimeValidation[3]">
        </app-rekbot-day-open-hours>
        <hr style="width:75%; margin:auto;">

        <app-rekbot-day-open-hours [settingsOpenHours]="rekbotSettings.open_hours[4]"
            [timeValidationErrors]="rekbotTimeValidation[4]">
        </app-rekbot-day-open-hours>
        <hr style="width:75%; margin:auto;">

        <app-rekbot-day-open-hours [settingsOpenHours]="rekbotSettings.open_hours[5]"
            [timeValidationErrors]="rekbotTimeValidation[5]">
        </app-rekbot-day-open-hours>
        <hr style="width:75%; margin:auto;">

        <app-rekbot-day-open-hours [settingsOpenHours]="rekbotSettings.open_hours[6]"
            [timeValidationErrors]="rekbotTimeValidation[6]">
        </app-rekbot-day-open-hours>

        <hr>

        <div class="row">
            <div class="col">
                <h4>Zestawienie</h4>
            </div>
        </div>
        <div class="row" style="margin-top:15px;">
            <div class="col">
                <app-rekbot-settings-email-list [emailService]="emailListService">
                </app-rekbot-settings-email-list>
            </div>
        </div>
        <div class="row" style="margin-top:15px;">
            <div class="col-2">
                <mat-slide-toggle class="example-margin" [checked]="rekbotSettings.report_daily"
                    [(ngModel)]="rekbotSettings.report_daily" [disabled]="disabled">
                    Dzienne raportowanie
                </mat-slide-toggle>
            </div>
            <div class="col-2">
                <mat-slide-toggle class="example-margin" [checked]="rekbotSettings.report_weekly"
                    [(ngModel)]="rekbotSettings.report_weekly" [disabled]="disabled">
                    Tygodniowe raportowanie
                </mat-slide-toggle>
            </div>
            <div class="col-6">
                <mat-slide-toggle class="example-margin" [checked]="rekbotSettings.report_monthly"
                    [(ngModel)]="rekbotSettings.report_monthly" [disabled]="disabled">
                    Miesięczne raportowanie
                </mat-slide-toggle>
            </div>
        </div>

        <hr>

        <div class="row">
            <div class="col">
                <h4>Wydruk</h4>
            </div>
        </div>
        <div class="d-flex flex-row gap-3 flex-wrap" style="margin-top:15px;">
                <mat-form-field appearance="outline">
                    <mat-label>Długość kodu kreskowego: </mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.barcode_length">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Prefix: </mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.barcode_prefix">
                </mat-form-field>
        </div>
        <div class="d-flex flex-row gap-3 flex-wrap" style="margin-top:15px;">
                <mat-form-field appearance="outline">
                    <mat-label>Rabat za puszki (groszy):</mat-label>

                    <input matInput type="text" [(ngModel)]="rekbotSettings.discount_can">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Rabat za butelki (groszy):</mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.discount_bottle">
                </mat-form-field>
        </div>
        <div class="row" style="margin-top:15px;">
                <mat-form-field style="width:500px;" appearance="outline">
                    <mat-label>Wzór wydruku</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="5" cdkAutosizeMaxRows="5"
                        [(ngModel)]="rekbotSettings.print_template"></textarea>
                </mat-form-field>
        </div>
        <hr>

        <div class="row">
            <div class="col">
                <h4>Raport o awarii</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-1"></div>
            <div class="col-11 d-flex flex-row align-content-center gap-5">
                <h5 class="m-0">Lokalizacja urządzenia</h5>
                <button *ngIf="isSuperadmin()" mat-flat-button class="btn btn-primary btn-action" color="accent"
                    (click)="setStdLocation()">Ustaw lokalizację magazyn Łajski</button>
            </div>
        </div>
        <div class="d-flex flex-row gap-3 flex-wrap" style="margin-top:15px;">
                <mat-form-field appearance="outline">
                    <mat-label>Ulica:</mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.street">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Miasto:</mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.city">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Kod pocztowy:</mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.post_code">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Kraj:</mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.country">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Szer.:</mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.lat">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Dł.:</mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.lon">
                </mat-form-field>
        </div>

        <hr>

        <div class="row">
            <div class="col-1"></div>
            <div class="col-11">
                <h5>Alert email</h5>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <app-rekbot-settings-email-list [emailService]="alertListService">
                </app-rekbot-settings-email-list>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-12">
                <h4>Kontakt</h4>
            </div>
        </div>
        <div class="d-flex flex-row gap-3 flex-wrap" style="margin-top:15px;">
                <mat-form-field appearance="outline">
                    <mat-label>Osoba:</mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.contact_person">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Firma:</mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.contact_company">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Telefon:</mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.contact_phone">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Email:</mat-label>
                    <input matInput type="email" [(ngModel)]="rekbotSettings.contact_email">
                </mat-form-field>
        </div>
        <hr>

        <div class="row">
            <div class="col-12">
                <h4>Ustawienia sprzetowe</h4>
            </div>
        </div>
        <div class="d-flex flex-row gap-3 flex-wrap" style="margin-top:15px;">
                <mat-form-field appearance="outline">
                    <mat-label>Wyświetlacz</mat-label>
                    <mat-select [(ngModel)]="rekbotSettings.display" name="display_">
                        @for (display of displays; track display) {
                        <mat-option [value]="display.value">{{display.value}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Skaner</mat-label>
                    <mat-select [(ngModel)]="rekbotSettings.scanner" name="scanner_">
                        @for (scanner of scanners; track scanner) {
                        <mat-option [value]="scanner.value">{{scanner.value}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
        </div>
        <hr>
        <div class="row">
            <div class="col-12">
                <h4>Ustawienia API</h4>
            </div>
        </div>
        <div class="row" style="margin-top:15px;">
            <div class="col-4">
                <mat-form-field style="width:100%;" appearance="outline">
                    <mat-label>Klucz API:</mat-label>
                    <input matInput type="text" [(ngModel)]="rekbotSettings.store_api_key"
                        style="width:100%;font-family:'Courier New', Courier, monospace;">
                </mat-form-field>
            </div>
        </div>
        <hr>

        <mat-error *ngIf="checkTimeValidation()">Proszę zweryfikować wprowadzone czasy</mat-error>

        <button *ngIf="0" mat-flat-button class="btn btn-primary btn-action" color="accent"
            (click)="toConsole()">Console</button>

        <button mat-flat-button class="btn btn-primary btn-action" color="accent"
            (click)="saveSettings()">Zapisz ustawienia
            Rekbot-a</button>


    </div>
    <div class="col-9">
        <!-- app-rekbot-list-small [selectedRekbotsIds]="selectedRekbotsIds"></app-rekbot-list-small -->
    </div>
</div>




<ng-template #SMTPModal let-modal style="width:1000px;">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Ustawienia SMTP Rekbot-a</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <app-settings-smtp-table *ngIf="rekbotAccounts.length" [accounts]="rekbotAccounts"></app-settings-smtp-table>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="modal.close('Close click');">Zamknij</button>
    </div>
</ng-template>